import { render, staticRenderFns } from "./FormLeaveType.vue?vue&type=template&id=08e69992"
import script from "./FormLeaveType.vue?vue&type=script&lang=js"
export * from "./FormLeaveType.vue?vue&type=script&lang=js"
import style0 from "./FormLeaveType.vue?vue&type=style&index=0&id=08e69992&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports